// PlayerCharacter.js - This file is now deprecated and has been refactored
// Please use the player/index.js file instead

// This file is kept for reference only and will be removed in a future update
import PlayerCharacter from './player/index';

export default PlayerCharacter;